import { Space, Row } from "@masterteam/mt-design-react";
import React from "react";

import DoughnutChart from "../../DoughnutChart";

import styles from "./DataChart.module.scss";

const DataChart = ({ data, statuses, title }) => {
  const totalCount = data?.reduce((allCount, item) => {
    return allCount + item?.Count;
  }, 0);

  return (
    <Row justify="center">
      <Space className={styles.chartWrapper} justify="center">
        <DoughnutChart
          data={data || []}
          statuses={statuses}
          count={totalCount}
          title={title}
          showStatuses
        />
      </Space>
    </Row>
  );
};

export default DataChart;
